import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getSlateColorToken } from "@faire/retailer-shared/SlateMappings/getSlateColorToken";
import { Pill } from "@faire/web--source/slate/Filter/styled";
import { Column } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import React from "react";
import { SDUIOnClickHandler } from "@faire/retailer/components/SDUI/__internal__/SDUIOnClickHandler/SDUIOnClickHandler";
import { SDUIImageOrIconRenderer } from "@faire/retailer/components/SDUI/ComponentRenderers/ImageOrIcon/SDUIImageOrIconRenderer";
import * as styles from "@faire/retailer/components/SDUI/ComponentRenderers/Tile/__internal__/styles/SDUIPillTileRenderer.css";
import { SDUITypographyRenderer } from "@faire/retailer/components/SDUI/ComponentRenderers/Typography/SDUITypographyRenderer";
export var SDUIPillTileRenderer = function(param) {
    var tileElement = param.tileElement, loggingData = param.loggingData;
    var on_click = tileElement.on_click;
    var _tileElement_pill_tile;
    var _ref = (_tileElement_pill_tile = tileElement.pill_tile) !== null && _tileElement_pill_tile !== void 0 ? _tileElement_pill_tile : {}, title = _ref.title, subtitle = _ref.subtitle, decoration = _ref.decoration, style = _ref.style;
    if (!title && !subtitle && !decoration) {
        return null;
    }
    return /*#__PURE__*/ _jsx(SDUIOnClickHandler, {
        onClickActions: on_click,
        loggingData: loggingData,
        logLegacyClickEvent: true,
        children: /*#__PURE__*/ _jsxs(Pill, {
            className: styles.sduiPillTileContainer,
            style: getBackground(style === null || style === void 0 ? void 0 : style.background_color),
            children: [
                decoration ? /*#__PURE__*/ _jsx(SDUIImageOrIconRenderer, {
                    imageOrIcon: decoration,
                    className: styles.sduiPillTileIcon
                }) : null,
                /*#__PURE__*/ _jsx(Spacer, {
                    width: "2x"
                }),
                /*#__PURE__*/ _jsxs(Column, {
                    children: [
                        title ? /*#__PURE__*/ _jsx(SDUITypographyRenderer, {
                            textElement: title,
                            loggingData: loggingData
                        }) : null,
                        subtitle ? /*#__PURE__*/ _jsx(SDUITypographyRenderer, {
                            textElement: subtitle,
                            loggingData: loggingData
                        }) : null
                    ]
                })
            ]
        })
    });
};
var getBackground = function(overrideBackgroundColor) {
    if (overrideBackgroundColor === null) {
        return {
            backgroundColor: "transparent"
        };
    } else if (overrideBackgroundColor) {
        return {
            backgroundColor: getSlateColorToken(overrideBackgroundColor)
        };
    } else {
        return undefined;
    }
};
